import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "dropdown-icon" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "dropdown-text" }
const _hoisted_4 = { class: "dropdown-label" }
const _hoisted_5 = {
  key: 0,
  class: "dropdown-count"
}
const _hoisted_6 = { class: "dropdown-menu" }
const _hoisted_7 = { class: "dropdown-search" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "dropdown-items" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "item-icon" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "item-label" }
const _hoisted_14 = {
  key: 0,
  class: "item-count"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["type-filter-dropdown", { open: $setup.isOpen }])
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "dropdown-toggle",
      onClick: $setup.toggle
    }, [
      _createElementVNode("span", _hoisted_1, [
        ($setup.selectedOption?.iconClass)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass($setup.selectedOption.iconClass)
            }, null, 2 /* CLASS */))
          : ($setup.selectedOption?.iconUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: $setup.selectedOption.iconUrl,
                alt: "",
                class: "type-icon"
              }, null, 8 /* PROPS */, _hoisted_2))
            : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString($setup.selectedOption?.label), 1 /* TEXT */),
        ($setup.selectedOption?.count != null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(" + _toDisplayString($setup.selectedOption.count) + ")", 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-chevron-down dropdown-arrow" }, null, -1 /* CACHED */))
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-search" }, null, -1 /* CACHED */)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.searchQuery) = $event)),
          type: "text",
          class: "dropdown-search-input",
          placeholder: $props.searchPlaceholder
        }, null, 8 /* PROPS */, _hoisted_8), [
          [_vModelText, $setup.searchQuery]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredOptions, (option) => {
          return (_openBlock(), _createElementBlock("button", {
            key: option.value,
            type: "button",
            class: _normalizeClass(["dropdown-item", { active: option.value === $props.modelValue }]),
            onClick: $event => ($setup.selectOption(option))
          }, [
            _createElementVNode("span", _hoisted_11, [
              (option.iconClass)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: _normalizeClass(option.iconClass)
                  }, null, 2 /* CLASS */))
                : (option.iconUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: option.iconUrl,
                      alt: "",
                      class: "type-icon"
                    }, null, 8 /* PROPS */, _hoisted_12))
                  : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("span", _hoisted_13, _toDisplayString(option.label), 1 /* TEXT */),
            (option.count != null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(option.count), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ], 10 /* CLASS, PROPS */, _hoisted_10))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, $setup.isOpen]
    ])
  ], 2 /* CLASS */))
}